module.exports = new __parcel__URL__("microsoft-logo.c73d8dca.svg").toString();